<template>
  <main id="authorProgs" v-if="isAuthed">
    <Toolbars ref="toolbars"
      :status="config.status"
      :authors="store.authors"
      :arrangers="store.arrangers"
      @emit="emitted"
    />
    <v-list class="pa-0 transparent">
      <v-list-item class="amber blue-grey--text text--darken-3 pa-0">
        <v-list-item-action class="mx-0">
          <v-btn icon text disabled color="transparent"></v-btn>
        </v-list-item-action>
        <v-list-item-content class="py-0">
          <v-row dense>
            <v-col class="text-center font-weight-black caption">大家</v-col>
            <v-col class="text-center font-weight-black caption">開始日</v-col>
            <v-col class="text-center font-weight-black caption">顧客名</v-col>
            <v-col class="text-center font-weight-black caption">申込確認</v-col>
            <v-col class="text-center font-weight-black caption">請求</v-col>
            <v-col class="text-center font-weight-black caption">滞在先</v-col>
            <v-col class="text-center font-weight-black caption">料金</v-col>
            <v-col class="text-center font-weight-black caption">送金</v-col>
          </v-row>
        </v-list-item-content>
        <v-list-item-action></v-list-item-action>
      </v-list-item>
      <v-progress-linear v-if="isLoading" class="ma-0" indeterminate color="blue"></v-progress-linear>
      <template v-for="item in getItems">
        <v-list-item :key="item.id" class="pa-0">
          <v-list-item-action class="mx-0">
            <v-menu bottom left offset-y>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" color="secondary"><v-icon small>fas fa-ellipsis-v</v-icon></v-btn>
              </template>
              <v-list class="py-0">
                <v-list-item v-if="item.authed && item.status === 'active'" @click.stop="submit({ id: item.id, type: 'cancel' })" class="red white--text">
                  <v-list-item-avatar><font-awesome-icon :icon="['fal', 'minus-circle']" /></v-list-item-avatar>
                  <v-list-item-content><v-list-item-title>キャンセル処理する</v-list-item-title></v-list-item-content>
                </v-list-item>
                <v-list-item v-if="item.authed && item.status === 'active'" @click.stop="submit({ id: item.id, type: 'done' })" class="green white--text">
                  <v-list-item-avatar><font-awesome-icon :icon="['fal', 'check-circle']" /></v-list-item-avatar>
                  <v-list-item-content><v-list-item-title>完了処理する</v-list-item-title></v-list-item-content>
                </v-list-item>
                <v-list-item v-if="item.authed && item.status === 'done'" @click.stop="submit({ id: item.id, type: 'progress' })" class="blue white--text">
                  <v-list-item-avatar><font-awesome-icon :icon="['fal', 'check-circle']" /></v-list-item-avatar>
                  <v-list-item-content><v-list-item-title>未完処理する</v-list-item-title></v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-list-item-action>
          <v-list-item-content class="py-0">
            <v-row dense>
              <v-col class="px-0">
                <v-btn text block class="caption px-0" @click.stop="open({ type: 'owner', item: item })" v-html="item.title"></v-btn>
              </v-col>
              <v-col class="px-0">
                <v-btn text block class="caption px-0" @click.stop="open({ type: 'date', item: item })">{{ item.date }}</v-btn>
              </v-col>
              <v-col class="px-0">
                <v-btn text block class="caption px-0" @click.stop="open({ type: 'client', item: item })">{{ item.name.join(' ') }}</v-btn>
              </v-col>
              <v-col class="px-0">
                <v-btn text block class="caption px-0" @click.stop="open({ type: 'app', item: item })">{{ item.app }}</v-btn>
              </v-col>
              <v-col class="px-0">
                <v-btn text block class="caption px-0" @click.stop="open({ type: 'charge', item: item })">{{ item.charge }}</v-btn>
              </v-col>
              <v-col class="px-0">
                <v-btn text block class="caption px-0" @click.stop="open({ type: 'house', item: item })" v-html="item.house"></v-btn>
              </v-col>
              <v-col class="px-0">
                <v-btn text block class="caption px-0" @click.stop="open({ type: 'fee', item: item })">{{ item.fee }}</v-btn>
              </v-col>
              <v-col class="px-0">
                <v-menu bottom left offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" text block
                      class="caption px-0"
                    >
                      {{ item.transfers && item.transfers.length ? ('送金（' + item.transfers.length + '）') : '未完' }}
                    </v-btn>
                  </template>
                  <v-list class="py-0">
                    <v-list-item v-for="jtem in item.transfers" :key="'transfer_' + jtem.id">
                      <v-list-item-content>
                        <v-list-item-subtitle class="caption">{{ jtem.content }}</v-list-item-subtitle>
                        <v-list-item-title>{{ jtem.option.sum }}</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-btn icon small
                          color="secondary"
                          @click.stop="open({ type: 'transfer', item: item, sid: jtem.id })"
                        ><v-icon small>fal fa-pencil</v-icon></v-btn>
                      </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="blue darken-2 white--text" @click.stop="open({ type: 'transfer', item: item })">
                      <v-list-item-icon><v-icon small color="secondary">fal fa-plus</v-icon></v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>送金を追加する</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action></v-list-item-action>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
        <v-divider :key="item.id + '_div'"></v-divider>
      </template>
    </v-list>
    <ModalOwner ref="ownerEditor" @done="update" />
    <ModalDate ref="dateEditor" @done="update" />
    <ModalApp ref="appEditor" @done="update" />
    <ModalCharge ref="chargeEditor" @done="update" />
    <ModalHouse ref="houseEditor" @done="update" />
    <ModalFee ref="feeEditor" @done="update" />
    <ModalTransfer ref="transferEditor" @done="update" />
    <ModalConfirm ref="confirmer" />
  </main>
</template>

<script>
import Toolbars from './toolbars'
import ModalOwner from './modals/owner'
import ModalDate from './modals/date'
import ModalApp from './modals/app'
import ModalHouse from './modals/house'
import ModalFee from './modals/fee'
import ModalCharge from './modals/charge'
import ModalTransfer from './modals/transfer'
import ModalConfirm from '@/components/modals/confirm'

const DEFAULT = {
  LOADING: false,
  FILTERED: 'off',
  LIMIT: 20,
  ORDER: {
    FIELD: 'id',
    DIR: 'desc'
  }
}
export default {
  name: 'authorStays',
  components: {
    Toolbars,
    ModalOwner,
    ModalDate,
    ModalApp,
    ModalHouse,
    ModalFee,
    ModalCharge,
    ModalTransfer,
    ModalConfirm
  },
  data () {
    return {
      config: {
        status: {
          loading: DEFAULT.LOADING,
          authed: false
        }
      },
      meta: {
        authors: {},
        arrangers: {},
        arrange: {
        }
      },
      store: {
        arranges: [],
        authors: [],
        arrangers: []
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init: function () {
      this.auth()
    },
    emitted: function (req) {
      if (
        req &&
        req.action &&
        typeof this[req.action] === 'function'
      ) {
        this[req.action](req.data)
      }
    },
    auth: function () {
      let auths = this.$store.getters['author/get']('authority')
      let permit = this.$route.meta.permit
      if (!auths.includes(permit)) {
        this.$router.push('/')
      } else {
        this.$set(this.config.status, 'authed', true)
      }
    },
    get: function (fm) {
      if (fm) {
        this.$set(this.config.status, 'loading', true)
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(this.$url.api + 'progs/get/items/stay', fm, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.$set(this.store, 'arranges', res.data.data.arranges)
              this.$refs.toolbars.count(res.data.data.count)
              // this.$refs.toolbars.count(res.data.data.count)
            }
            this.$set(this.config.status, 'loading', false)
          }).catch(err => {
            console.log(err)
            this.$set(this.config.status, 'loading', false)
          })
        })
      }
    },
    update: function (res) {
      const { id, type, value } = res
      if (id && type && value) {
        let idx = this.store.arranges.findIndex(it => {
          return (it.arrange && it.arrange.id && it.arrange.id === id)
        })
        if (idx >= 0) {
          if (type === 'date') {
            this.$set(this.store.arranges[idx].arrange, 'start', value)
          } else if (type === 'app') {
            this.$set(this.store.arranges[idx].arrange.app, 'content', value.date ? value.date : '')
            this.$set(this.store.arranges[idx].arrange.app, 'option', {
              owner: value.owner ? value.owner : '',
              house: {
                name: (value.house && value.house.name) ? value.house.name : '',
                in: (value.house && value.house.in) ? value.house.in : '',
                out: (value.house && value.house.out) ? value.house.out : ''
              }
            })
          } else if (type === 'charge') {
            this.$set(this.store.arranges[idx].arrange.charge, 'content', value.date)
            this.$set(this.store.arranges[idx].arrange.charge, 'option', {
              handling: value.handling,
              pickup: value.pickup,
              orientation: value.orientation,
              gross: value.gross,
              net: value.net
            })
          } else if (type === 'stay') {
            this.$set(this.store.arranges[idx].arrange.stay, 'content', value)
          } else if (type === 'transfer') {
            const { sid, date, sum } = value
            let jdx = this.store.arranges[idx].arrange.transfers.findIndex(it => {
              return it.id === sid
            })
            if (jdx >= 0) {
              this.$set(this.store.arranges[idx].arrange.transfers[jdx], 'content', date)
              this.$set(this.store.arranges[idx].arrange.transfers[jdx], 'option', {
                sum: sum
              })
            } else {
              this.store.arranges[idx].arrange.transfers.push({
                id: sid,
                content: date,
                option: {
                  sum: sum
                }
              })
            }
          }
        }
      }
    },
    edit: function (item) {
      let idx = this.store.arranges.findIndex(it => {
        return !!(
          it.arrange &&
          it.arrange.id &&
          item.id === it.arrange.id
        )
      })
      if (idx >= 0) {
        this.$refs.commander.open()
      }
    },
    open: function (req) {
      const { type, item, sid } = req
      if (type && item && item.id) {
        let idx = this.store.arranges.findIndex(it => {
          return it.arrange.id === item.id
        })
        let dt = this.store.arranges[idx]
        if (type === 'client' && dt.client.id) {
          let resolve = this.$router.resolve({ path: '../client/' + dt.client.id })
          window.open(resolve.href, '_blank')
        } else if (type === 'date') {
          this.$refs.dateEditor.open({
            id: dt.arrange.id,
            date: dt.arrange.start ? dt.arrange.start : ''
          })
        } else if (type === 'owner') {
          this.$refs.ownerEditor.open({
            id: dt.arrange.app.id,
            cid: dt.arrange.id,
            clientId: dt.client.id,
            authed: (dt.arrange.aid === this.$store.getters['author/get']('userid') || this.$store.getters['author/get']('roles').includes('developer')),
            mid: dt.arrange.media,
            date: dt.arrange.app.content,
            owner: dt.arrange.app.option ? dt.arrange.app.option.owner : '',
            house: {
              name: (dt.arrange.app.option && dt.arrange.app.option.house) ? dt.arrange.app.option.house.name : '',
              in: (dt.arrange.app.option && dt.arrange.app.option.house) ? dt.arrange.app.option.house.in : '',
              out: (dt.arrange.app.option && dt.arrange.app.option.house) ? dt.arrange.app.option.house.out : ''
            }
          })
        } else if (type === 'app') {
          this.$refs.appEditor.open({
            id: dt.arrange.app.id,
            cid: dt.arrange.id,
            clientId: dt.client.id,
            authed: (dt.arrange.aid === this.$store.getters['author/get']('userid') || this.$store.getters['author/get']('roles').includes('developer')),
            mid: dt.arrange.media,
            date: dt.arrange.app.content,
            owner: dt.arrange.app.option ? dt.arrange.app.option.owner : '',
            house: {
              name: (dt.arrange.app.option && dt.arrange.app.option.house) ? dt.arrange.app.option.house.name : '',
              in: (dt.arrange.app.option && dt.arrange.app.option.house) ? dt.arrange.app.option.house.in : '',
              out: (dt.arrange.app.option && dt.arrange.app.option.house) ? dt.arrange.app.option.house.out : ''
            }
          })
        } else if (type === 'charge') {
          this.$refs.chargeEditor.open({
            id: dt.arrange.charge.id,
            cid: dt.arrange.id,
            clientId: dt.client.id,
            authed: (dt.arrange.aid === this.$store.getters['author/get']('userid') || this.$store.getters['author/get']('roles').includes('developer')),
            mid: dt.arrange.media,
            date: dt.arrange.charge.content,
            handling: dt.arrange.charge.option ? dt.arrange.charge.option.handling : '',
            pickup: dt.arrange.charge.option ? dt.arrange.charge.option.pickup : '',
            orientation: dt.arrange.charge.option ? dt.arrange.charge.option.orientation : '',
            gross: dt.arrange.charge.option ? dt.arrange.charge.option.gross : '',
            net: dt.arrange.charge.option ? dt.arrange.charge.option.net : ''
          })
        } else if (type === 'house') {
          this.$refs.houseEditor.open({
            id: dt.arrange.app.id,
            cid: dt.arrange.id,
            clientId: dt.client.id,
            authed: (dt.arrange.aid === this.$store.getters['author/get']('userid') || this.$store.getters['author/get']('roles').includes('developer')),
            mid: dt.arrange.media,
            date: dt.arrange.app.content,
            owner: dt.arrange.app.option ? dt.arrange.app.option.owner : '',
            house: {
              name: (dt.arrange.app.option && dt.arrange.app.option.house) ? dt.arrange.app.option.house.name : '',
              in: (dt.arrange.app.option && dt.arrange.app.option.house) ? dt.arrange.app.option.house.in : '',
              out: (dt.arrange.app.option && dt.arrange.app.option.house) ? dt.arrange.app.option.house.out : ''
            }
          })
        } else if (type === 'fee') {
          this.$refs.feeEditor.open({
            id: dt.arrange.charge.id,
            cid: dt.arrange.id,
            clientId: dt.client.id,
            authed: (dt.arrange.aid === this.$store.getters['author/get']('userid') || this.$store.getters['author/get']('roles').includes('developer')),
            mid: dt.arrange.media,
            date: dt.arrange.charge.content,
            handling: dt.arrange.charge.option ? dt.arrange.charge.option.handling : '',
            pickup: dt.arrange.charge.option ? dt.arrange.charge.option.pickup : '',
            orientation: dt.arrange.charge.option ? dt.arrange.charge.option.orientation : '',
            gross: dt.arrange.charge.option ? dt.arrange.charge.option.gross : '',
            net: dt.arrange.charge.option ? dt.arrange.charge.option.net : ''
          })
        } else if (type === 'transfer') {
          if (sid) {
            let jdx = dt.arrange.transfers.findIndex(it => {
              return it.id === sid
            })
            if (jdx >= 0) {
              let jtem = dt.arrange.transfers[jdx]
              this.$refs.transferEditor.open({
                id: jtem.id,
                cid: dt.arrange.id,
                clientId: dt.client.id,
                sum: jtem.option && jtem.option.sum ? jtem.option.sum : '',
                date: jtem.content
              })
            }
          } else {
            this.$refs.transferEditor.open({
              id: '',
              cid: dt.arrange.id,
              clientId: dt.client.id,
              sum: '',
              date: ''
            })
          }
        }
      }
    },
    submit: function (req) {
      const { id, type } = req
      const types = {
        done: {
          title: '完了処理する',
          message: 'この手配を完了済みにしてもよろしいですか？',
          colors: {
            title: 'green white--text'
          },
          req: {
            id: id,
            status: 'done'
          }
        },
        cancel: {
          title: 'キャンセル処理する',
          message: 'この手配をキャンセルしてもよろしいですか？',
          colors: {
            title: 'red white--text'
          },
          req: {
            id: id,
            status: 'cancel'
          }
        },
        progress: {
          title: '未完処理する',
          message: 'この手配を未完状態に戻してもよろしいですか？',
          req: {
            id: id,
            status: 'active'
          }
        }
      }
      if (types[type]) {
        const dt = types[type]
        this.$refs.confirmer.open(Object.assign(dt, {
          callback: () => {
            const { id, status } = dt.req
            this.$set(this.config.status, 'loading', true)
            this.$firebase.auth().currentUser.getIdToken(true).then(token => {
              this.axios.post(this.$url.api + 'progs/update/item/stay', {
                id: id,
                status: status
              }, {
                headers: {
                  'firebase-token': token
                }
              }).then(res => {
                console.log(res)
                if (res.data && res.data.success) {
                  this.$nextTick(() => {
                    const fm = this.$refs.toolbars.getForm()
                    console.log(fm)
                    this.get(fm)
                  })
                }
                this.$set(this.config.status, 'loading', false)
              }).catch(err => {
                console.log(err)
                this.$set(this.config.status, 'loading', false)
              })
            })
          }
        }))
      }
    },
    loadLegacy: function () {
      console.log('USERID: ' + this.$store.getters['author/get']('userid'))
      this.$refs.media_aid.value = this.$store.getters['author/get']('userid')
      this.$nextTick(() => {
        this.$refs.legacyForm.submit()
      })
    }
  },
  computed: {
    printURL () {
      return 'https://legacy.sasmango.com/sas/author/acomm?status=process'
    },
    isAuthed () {
      return this.config.status.authed
    },
    isDevMode () {
      return this.$store.getters['author/get']('dev')
    },
    isLoading () {
      return this.config.status.loading
    },
    getItems () {
      return this.store.arranges.map(it => {
        const { arrange, client } = it
        const { id, aid, start, title, status, app, charge, transfers } = arrange
        return {
          id: id,
          cid: client.id,
          authed: aid === this.$store.getters['author/get']('userid') || this.$store.getters['author/get']('roles').includes('developer'),
          aid: aid,
          date: start ? this.$moment(start).format('YY/MM/DD') : '',
          name: client.name.split(','),
          title: [title].concat((app && app.option && app.option.owner && this.$mango.arrange.stay.owners[app.option.owner]) ? [this.$mango.arrange.stay.owners[app.option.owner]] : []).join('<br />'),
          status: status,
          app: (app && app.content) ? this.$moment(app.content).format('YY/MM/DD') : '未完',
          charge: (charge && charge.content) ? this.$moment(charge.content).format('YY/MM/DD') : '未完',
          house: (app && app.option && app.option.house) ? (('未入力(' + (Object.keys(app.option.house).filter(key => {
            return app.option.house[key] === ''
          }).length) + ')').replace('未入力(0)', '入力完了')) : '未完',
          fee: (charge && charge.option) ? (('未入力(' + (Object.keys(charge.option).filter(key => {
            return charge.option[key] === ''
          }).length) + ')').replace('未入力(0)', '入力完了')) : '未完',
          transfers: transfers.map(it => {
            return {
              id: it.id,
              content: it.content ? this.$moment(it.content).format('YY/MM/DD') : '',
              option: it.option ? it.option : {
                sum: ''
              }
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss">
#authorProgs {
}
</style>
